import React, {Component} from 'react';
import {connect} from 'react-redux';
import PremiumSettingsWizard from "../../components/PremiumSettings/premiumSettingsWizard";
import {
	changePremiumSettingsWizardStore, changePremiumSettingsWizardStoreByDamageAndCaseStage,
	changePremiumSettingsWizardStoreByDamageCaseStageAndSolicitor,
	changeWizardStep, getPremiumSettingsWizardStepMessages, postNewPremiumSettingWizard,getCoverageTypes
} from "../../actions/premiumSettingsWizard";
import {requestLawsysFirmsFiltered, changeLawsysFirmState} from "../../actions/lawsysFirms";
import {
	requestGetSpecificPremiumSetting, requestPatchPremiumSetting, requestPremiumSettingsDamages,
	requestPremiumSettingsStages
} from "../../actions/premiumSettings";
import _ from 'lodash';
import accounting from 'accounting';
import {getCaseTypes} from "../../actions/caseTypes";
import moment from "moment";
import {CANADA_COUNTRY, COUNTRY, CURRENCY, DATE_REGURAL_EXPRESSION} from "../../helpers/variables";
import {areEntitiesWithIdsEqual, getHtmlValidDate, getParameterByName} from "../../helpers/functions";
import { goBack } from 'connected-react-router';
import {changeApplicationPolicySettings, requestDeleteApplicationPremiumSettings, requestPatchApplicationPremiumSettings} from "../../actions/applicationPolicy";
import { PS_TYPE_CUSTOM, PS_TYPE_PERCENTAGE } from '../../helpers/constants';

class PremiumSettingsWizardHOC extends Component {

	componentWillMount() {
		//redirected with template?
		if (COUNTRY == CANADA_COUNTRY) {
			this.props.getCoverageTypes();
		}
		if(
			this.props.location
			&& this.props.location.search
			&& getParameterByName("psId")
		){
			const psId = getParameterByName("psId");
			this.props.requestGetSpecificPremiumSetting({
				premiumSettingId: psId,
				isEditMode: false,
				premiumSettingTypePercentage: this.props.premiumSettingType === PS_TYPE_PERCENTAGE
			});
			this.props.getPremiumSettingsWizardStepMessages(); // fetch step messages
			return null;
		}

		if (this.props.match) { // if route is edit premium settings the order of the requests in important ino order to construct the store
			if(this.props.match.params.id){
                this.props.requestGetSpecificPremiumSetting({
					premiumSettingId: this.props.match.params.id,
					isEditMode: true,
					premiumSettingTypePercentage: this.props.premiumSettingType === PS_TYPE_PERCENTAGE
				});
                this.props.getPremiumSettingsWizardStepMessages(); // fetch step messages
                return null;
            }

		}

		if (!this.props.showTable) { // if showTable is true this means that only the overview of an existing premium setting will be displayed
			this.props.requestPremiumSettingsDamages(); //fetch damages
			this.props.getCaseTypes(); //fetch case types
			//this.props.requestLawsysFirms(); // fetch solicitors
		}
		this.props.requestPremiumSettingsStages(); //fetch case stages
		this.props.getPremiumSettingsWizardStepMessages(); // fetch step messages
	}


	componentDidUpdate(prevProps, prevState) {
        clearTimeout(this.askServer);
        if(this.props.lawsysFirms.suggestionFieldValue !== prevProps.lawsysFirms.suggestionFieldValue
            && this.props.lawsysFirms.suggestionFieldValue.length >= 3)
        {
            this.askServer = setTimeout(() => {
                this.props.requestLawsysFirmsFiltered( {
                    search:  this.props.lawsysFirms.suggestionFieldValue,
                })
            }, 500);
        }
    }

	//function that handles the date inputs change
	handleDateChange = (name, value, minDate, maxDate) => {
		if(!value){ //if value is  undefined
			if(name.target.value.length >= 8) {
				let split = name.target.value.split('/');
				if(split.length === 3){
					if(split[2].length === 4){
						let d = getHtmlValidDate(name.target.value);

						if (!name.target.value.match(DATE_REGURAL_EXPRESSION)) { //if the date is invalid
							this.props.changeStoreSettings(name.target.name, '');
							return false;
						}
						else {
							if (minDate) { //if minDate exists
								let t = getHtmlValidDate(minDate);
								if (moment(d).isBefore(t)) {
									this.props.changeStoreSettings(name.target.name, '')
									return false;
								}
							}
							if (maxDate) { //if max date exists
								let t = getHtmlValidDate(maxDate);
								if (moment(d).isAfter(t)) {
									this.props.changeStoreSettings(name.target.name, '')
									return false;
								}
							}
						}
					}
				}
			}
		}
		value !== undefined? //when user wants to clear the date the value is undefined
			(this.props.changeStoreSettings(name, value)):  this.props.changeStoreSettings(name.target.name, name.target.value);
	};

	handleCaseStagesSelectMultipleChange = (isChecked, stage) => {
		let newStages = [];
		if(!isChecked && (stage.name === 'Pre-Issue')){
			return ;
		}

		if(isChecked){
			newStages = [...this.props.premiumSettingsWizard.selectedCaseStages, stage];
		} else {
			newStages = this.props.premiumSettingsWizard.selectedCaseStages.filter(item => item.id !== stage.id);
		}

		this.props.changeStoreSettings('selectedCaseStages', newStages);
	};

	handleCaseStagesCheckedState = (stageId) => {
		try {
			return !!this.props.premiumSettingsWizard.selectedCaseStages.find(item => item.id === stageId)
		} catch (e) {
			return false
		}
	};

	addNewDamageBand = () => {
		let selectedDamages = [...this.props.premiumSettingsWizard.selectedDamages];
		let damageBands = [...this.props.premiumSettingsWizard.damageBands];
		let damages = [...this.props.damages];
		let newDamageBands = [];
		if (damageBands.length === 1) {
			if (damageBands[0].length === damages.length) {
				newDamageBands = [_.orderBy(selectedDamages, (item) => item.sortOrder)]
			}
			else {
				newDamageBands = [...damageBands, _.orderBy(selectedDamages, (item) => item.sortOrder)]
			}
		}
		else {
			newDamageBands = [...damageBands, _.orderBy(selectedDamages, (item) => item.sortOrder)]
		}
		this.props.changeStoreSettings('openDamageBandModal', false);
		this.props.changeStoreSettings('damageBands', this.sortDamageBands(newDamageBands));
		this.props.changeStoreSettings('selectedDamages', []);
		this.props.changeStoreSettings('checkedDamagesIds', []);
	};

	getDamageItem = (damageId) => { //helper function that gets damage item by id
		let damages = [...this.props.damages];
		return _.find(damages, (item) => {
			return item.id === damageId
		});
	};

	getDamagesNotInDamageBands = () => {
		let damageBands = [...this.props.premiumSettingsWizard.damageBands];
		let damages = [...this.props.damages];
		let damagesInDamageBands = [];
		let damagesNotInDamageBands = [];
		if (damageBands.length === 0)
			return damages;
		if (damageBands.length === 1) {
			if (damageBands[0].length === damages.length) {
				return [];
			}
		}
		for (let i = 0; i < damageBands.length; i++) {
			damagesInDamageBands = [...damagesInDamageBands, ...damageBands[i]];
		}
		for (let i = 0; i < damages.length; i++) {
			let item = _.find(damagesInDamageBands, (item) => {
				return item.id === damages[i].id
			});
			if (!item) {
				damagesNotInDamageBands = [...damagesNotInDamageBands, damages[i]]
			}
		}
		damagesNotInDamageBands = _.orderBy(damagesNotInDamageBands, (item) => item.sortOrder);
		return damagesNotInDamageBands
	};

	//function that calculates the damage band label
	getDamageBandName = (damageBand) => {
		let damages = [...this.props.damages];
		if (damageBand.length === damages.length) {
			return 'Unlimited'
		}
		else {
			if(!_.last(damageBand)){
				return ''
			}

			if (_.last(damageBand).highValue === 0) {
				return 'Over ' + accounting.formatMoney(damageBand[0].lowValue - 1, `${CURRENCY} `, 0);
			}
			else {
				return accounting.formatMoney(damageBand[0].lowValue, `${CURRENCY} `, 0) + ' - ' + accounting.formatMoney(_.last(damageBand).highValue, `${CURRENCY} `, 0);
			}
		}
	};

	//function that sorts the damage bands
	sortDamageBands = (damageBands) => {
		return _.sortBy(damageBands, (band) => band[0].lowValue);
	};

	//function that calculates the damage band according to the given design
	setDamageBand = () => {
		let damageBands = [...this.props.premiumSettingsWizard.damageBands];
		let damages = [...this.props.damages];
		let startOfDamageBand = this.props.premiumSettingsWizard.startOfDamageBand;
		let endOfDamageBand = this.props.premiumSettingsWizard.endOfDamageBand;
		let startOfDamageBandObject = _.find(damages, (item) => item.id.toString() === startOfDamageBand);
		let endOfDamageBandSortObject = _.find(damages, (item) => item.id.toString() === endOfDamageBand);
		let newDamageBand = [];
		let newDamageBands = [];

		if(!endOfDamageBandSortObject) {
			return null;
		}

		if (startOfDamageBandObject && endOfDamageBandSortObject) {
			_.forEach(damages, damage => {
				if (startOfDamageBandObject.sortOrder <= damage.sortOrder && (damage.sortOrder <= endOfDamageBandSortObject.sortOrder)) {
					newDamageBand.push(damage)
				}
			});
		}
		else if (startOfDamageBandObject) {
			newDamageBand.push(startOfDamageBandObject)
		}
		else {
			return null
		}
		if (damageBands.length === 1) {
			if (damageBands[0].length === damages.length) {
				newDamageBands = [newDamageBand]
			}
			else {
				newDamageBands = [...damageBands, newDamageBand]
			}
		}
		else {
			newDamageBands = [...damageBands, newDamageBand]
		}


		let damagesInDamageBands = [];
		let damagesNotInDamageBands = [];
		if (newDamageBands.length === 0)
			return damages;
		if (newDamageBands.length === 1) {
			if (newDamageBands[0].length === damages.length) {
                this.props.changeStoreSettings('damageBands', [damages]);
                this.props.changeStoreSettings('openDamageBandModal', false);
                this.props.changeStoreSettings('selectedDamages', []);
                this.props.changeStoreSettings('checkedDamagesIds', []);
				return false;
			}
		}
		for (let i = 0; i < newDamageBands.length; i++) {
			damagesInDamageBands = [...damagesInDamageBands, ...newDamageBands[i]];
		}
		for (let i = 0; i < damages.length; i++) {
			let item = _.find(damagesInDamageBands, (item) => {
				return item.id === damages[i].id
			});
			if (!item) {
				damagesNotInDamageBands = [...damagesNotInDamageBands, damages[i]]
			}
		}
		damagesNotInDamageBands = _.orderBy(damagesNotInDamageBands, (item) => item.sortOrder);
		let finalDamageBands = [...newDamageBands];
		if (damagesNotInDamageBands.length > 0) {
			if (newDamageBands.length === 0) {
				this.props.changeStoreSettings('damageBands', [damages]);
			}
			else {
				if (newDamageBands.length === 1) {
					if (newDamageBands[0].length === damages.length) {
						this.props.changeStoreSettings('damageBands', [damages]);
						this.props.changeWizardStep('increase')
						return null;
					}
				}
				let tempDamageBand = [];
				_.forEach(damagesNotInDamageBands, (item, index) => {
					if (index === 0) {
						tempDamageBand.push(item)
						if (index + 1 === damagesNotInDamageBands.length) {
							finalDamageBands.push(tempDamageBand);
							tempDamageBand = [];
						}
					}
					else if (index + 1 === damagesNotInDamageBands.length) {
						if (this.areDamagesNeighbors(damagesNotInDamageBands[index - 1].sortOrder, item.sortOrder)) {
							tempDamageBand.push(item);
							finalDamageBands.push(tempDamageBand);
						}
						else {
							if(tempDamageBand.length > 0){ finalDamageBands.push(tempDamageBand) }
							finalDamageBands.push([item]);
						}
						tempDamageBand = [];
					}
					else if (this.areDamagesNeighbors(damagesNotInDamageBands[index - 1].sortOrder, item.sortOrder)) {
						tempDamageBand.push(item)

					}
					else if (!this.areDamagesNeighbors(damagesNotInDamageBands[index - 1].sortOrder, item.sortOrder)) {
						finalDamageBands.push(tempDamageBand);
						tempDamageBand = [item];
					}
				});
				this.props.changeStoreSettings('damageBands', this.sortDamageBands(finalDamageBands));
			}
		} else {
			this.props.changeStoreSettings('damageBands', this.sortDamageBands(finalDamageBands));
		}


		this.props.changeStoreSettings('openDamageBandModal', false);
		this.props.changeStoreSettings('selectedDamages', []);
		this.props.changeStoreSettings('checkedDamagesIds', []);
	};

	//function that gets the damage objects available for the first select list of the damage modal
	getStartDamageBands = () => {
		return [{key: '', value: ''}, ...this.getDamagesNotInDamageBands().map(damage => {
			return {key: damage.id, value: accounting.formatMoney(damage.lowValue, `${CURRENCY} `, 0) }
		})]
	};

	//function that returns true if the 2 damage bands sort order are neighbors , else it returns false
	areDamagesNeighbors = (damageSortOrder1, damageSortOrder2) => {
		let index = _.findIndex(this.props.damagesSortOrders, item => {return item === damageSortOrder1}) //finds the index in the damagesSortOrder
		if(this.props.damagesSortOrders[index + 1] === damageSortOrder2){
			return true;
		}
		else {
			return false;
		}
	};

	//function that gets the damage objects available for the second select list of the damage modal
	getEndDamageBands = () => {
		let damages = [...this.props.damages];
		let startOfDamageBand = this.props.premiumSettingsWizard.startOfDamageBand;
		let startOfDamageBandObject = _.find(damages, (item) => item.id.toString() === startOfDamageBand);
		let damagesNotInDamageBands = this.getDamagesNotInDamageBands();
		let filtered1 = [];
		if (startOfDamageBandObject) {
			filtered1 = _.filter(damagesNotInDamageBands, item => {
				return (item.sortOrder >= startOfDamageBandObject.sortOrder)
			});
		}
		let filtered2 = [];
		if (filtered1.length > 0) {
			_.forEach(filtered1, (item, index) => {
				if (index === 0) {
					filtered2.push(item);
				}
				else if (index <= filtered1.length){
					if(this.areDamagesNeighbors(filtered1[index - 1].sortOrder, item.sortOrder)){
						filtered2.push(item);
					}
					else return false;
				}
			});
		}
		if (damagesNotInDamageBands.length > 0 && startOfDamageBandObject) {
			return [{key: '', value: ''}, ...filtered2.map(damage => {
				return {key: damage.id, value:damage.highValue ? accounting.formatMoney(damage.highValue, `${CURRENCY} `, 0):'Unlimited'}
			})];
		}
		else {
			return [];
		}
	};

	// function that changes step through progress bar
	changeStepThroughProgressBar = (newStep) => {
		if (newStep < this.props.premiumSettingsWizard.currentStep)
			this.props.changeStoreSettings('currentStep', newStep);
	};

	//function that removes a damage band
	removeDamageBand = (damageBandIndex) => {
		let damageBands = [...this.props.premiumSettingsWizard.damageBands];
		damageBands.splice(damageBandIndex, 1);
		this.props.changeStoreSettings('damageBands', damageBands);
	};


	//function that add a solicitor to the solicitor list
	addSolicitor = () => {
		let solicitorId = this.props.premiumSettingsWizard.selectedSolicitor;
		let solicitorsList = [...this.props.premiumSettingsWizard.solicitorsList];
		solicitorsList.push(_.find(this.props.lawsysFirms.lawsysFirms, item => {
			return solicitorId.toString() === item.id.toString()
		}));
		this.props.changeStoreSettings('solicitorsList', _.sortBy(solicitorsList, ['id']));
		this.props.changeStoreSettings('openSolicitorModal', false);
		this.props.changeLawsysFirmState('suggestionFieldValue', '');
		this.props.changeLawsysFirmState('lawsysFirmsFiltered', []);
		this.props.changeLawsysFirmState('selectedLawsysFirmsDropdown', []);
		this.props.changeStoreSettings('selectedSolicitor', '');
	};

	//function that removes a solicitor from the list
	removeSolicitor = (solicitorIndex) => {
		let solicitorsList = [...this.props.premiumSettingsWizard.solicitorsList];
		solicitorsList.splice(solicitorIndex, 1);
		this.props.changeStoreSettings('solicitorsList', solicitorsList);
	};

	//function that calculated the table header data
	getTableHeaderData = () => {

		let damageBands = [...this.props.premiumSettingsWizard.damageBands];
		let headerData = [{width: '', label: ''}, {width: '', label: ''}];
		_.forEach(damageBands, band => {
			headerData.push({
				width: '220px',
				label: this.getDamageBandName(band)
			})
		});
		return headerData
	};

	//function that computes the sendBody for the api and the store
	setStorePremiumSettingsObject = () => {
		//Create the store for the table for the step4
		let tableData = [];
		_.forEach(this.props.premiumSettingsWizard.damageBands, (damageBand, index) => {
			let damageBandIndex = index;
			let damages = [];
			_.forEach(damageBand, band => {
				damages.push({
					id: band.id
				})
			});
			_.forEach(this.props.premiumSettingsWizard.selectedCaseStages, caseStage => {

				const sector = this.props.premiumSettingsWizard.tableData.find(data => {
					return (
						data.stageId === caseStage.id &&  areEntitiesWithIdsEqual(damageBand, data.damages)

					)
				});

				//Get solicitor firms for rows
				let premiumSubSettingCommissions = [];
				_.forEach(this.props.premiumSettingsWizard.solicitorsList, solicitor => {
					const sectorMatch = sector?
						sector.premiumSubSettingCommissions.find(item => item.lawsysId === solicitor.id):null;
					premiumSubSettingCommissions.push({
						lawsysId: solicitor.id,
						lawsysName: solicitor.name,
						commission: sectorMatch?sectorMatch.commission:'',
						commissionPercentage: sectorMatch?sectorMatch.commissionPercentage:''
					})
				});
				tableData.push({
                    stageName: caseStage?caseStage.name: null,
					stageId: caseStage.id,
					premium: sector?sector.premium:'',
					recoverable: sector?sector.recoverable:'',
					nonRecoverable: sector?sector.nonRecoverable:'',
					underwriterRate: sector?sector.underwriterRate:'',
					underwriterRatePercentage: sector?sector.underwriterRatePercentage:'',
					premiumSubSettingCommissions: premiumSubSettingCommissions,
					damages: damages,
					damageBandIndex: damageBandIndex
				})
			});
		});

		// Dispatching the tableData to store
		this.props.changeStoreSettings('tableData', tableData);
	};

	//function that changes the store underwriter and premium
	handlePremiumAndUnderwriterChange = (field, value, tableIndex) => {
		if(this.props.premiumSettingsWizard.tableData[tableIndex].premium === '' &&  field !=='premium'){
			return null;
		}
		if(field === 'premium') {//when user specifies premium underwriter rate , its percentage and the solicitor commissions must be filled from the start
			this.props.changeStore2(field, value, tableIndex);
			this.props.changeStore2('underwriterRate', '', tableIndex);
			this.props.changeStore2('underwriterRatePercentage', '', tableIndex);
			this.props.changeStore2('recoverable', '', tableIndex);
			this.props.changeStore2('nonRecoverable', '', tableIndex);
			_.forEach(this.props.premiumSettingsWizard.tableData[tableIndex].premiumSubSettingCommissions, (item, index) => {
				this.props.changeStore3('commission', '', tableIndex, index);
				this.props.changeStore3('commissionPercentage', '', tableIndex, index);
			})
		}
		else if(field === 'underwriterRate'){
			if(value === ''){
				this.props.changeStore2(field, value, tableIndex);
				this.props.changeStore2('underwriterRatePercentage', '', tableIndex);
			}
			else {
				let floatParsed = parseFloat(value);
				let premiumFloat = parseFloat(this.props.premiumSettingsWizard.tableData[tableIndex].premium);
				this.props.changeStore2(field, value, tableIndex);
				this.props.changeStore2('underwriterRatePercentage', _.round((floatParsed/premiumFloat)*100.0000, 4).toString() , tableIndex);

			}
		}
		else if(field === 'underwriterRatePercentage'){
			if(value === ''){
				this.props.changeStore2(field, value, tableIndex);
				this.props.changeStore2('underwriterRate', '', tableIndex);
			}
			else {
				let floatParsed = parseFloat(value);
				let premiumFloat = parseFloat(this.props.premiumSettingsWizard.tableData[tableIndex].premium);
				this.props.changeStore2(field, value, tableIndex);
				this.props.changeStore2('underwriterRate', _.round((floatParsed/100)*premiumFloat, 4).toString() , tableIndex);
			}
		}
	};

	//function that changes the store commissions
	handleCommissionChange = (field, value, tableIndex, solicitorId) => {
		if(this.props.premiumSettingsWizard.tableData[tableIndex].premium === ''){
			return null;
		}
		if(field === 'commission'){
			if(value === ''){
				this.props.changeStore3(field, value,tableIndex, solicitorId);
				this.props.changeStore3('commissionPercentage', '', tableIndex, solicitorId);
			}
			else {
				let floatParsed = parseFloat(value);
				let premiumFloat = parseFloat(this.props.premiumSettingsWizard.tableData[tableIndex].premium);
				this.props.changeStore3(field, value,tableIndex, solicitorId);
				this.props.changeStore3('commissionPercentage', _.round((floatParsed/premiumFloat)*100.0000, 4).toString() , tableIndex, solicitorId);
			}
		}
		else if(field === 'commissionPercentage'){
			if(value === ''){
				this.props.changeStore3(field, value,tableIndex, solicitorId);
				this.props.changeStore3('commission', '', tableIndex, solicitorId);
			}
			else {
				let floatParsed = parseFloat(value);
				let premiumFloat = parseFloat(this.props.premiumSettingsWizard.tableData[tableIndex].premium);
				this.props.changeStore3(field, value,tableIndex, solicitorId);
				this.props.changeStore3('commission', _.round((floatParsed/100)*premiumFloat, 4).toString() , tableIndex, solicitorId);
			}
		}
	};

	//function that changes the store recoverable and non recoverable
	handleRecoverableAndNonRecoverableChange = (field, value, tableIndex) => {
		if(this.props.premiumSettingsWizard.tableData[tableIndex].premium === ''){
			return null;
		}
		if(field === 'recoverable') {//when user specifies premium underwriter rate , its percentage and the solicitor commissions must be filled from the start
			if(value === ''){
				this.props.changeStore2('nonRecoverable', '', tableIndex);
				this.props.changeStore2('recoverable', '', tableIndex);
			}
			else {
				let premiumFloat = parseFloat(this.props.premiumSettingsWizard.tableData[tableIndex].premium);
				this.props.changeStore2(field, value, tableIndex);
				this.props.changeStore2('nonRecoverable', (_.round(premiumFloat - parseFloat(value), 4)).toString(), tableIndex);
			}
		}
		else if(field === 'nonRecoverable'){
			if(value === ''){
				this.props.changeStore2('nonRecoverable', '', tableIndex);
				this.props.changeStore2('recoverable', '', tableIndex);
			}
			else {
				let premiumFloat = parseFloat(this.props.premiumSettingsWizard.tableData[tableIndex].premium);
				this.props.changeStore2(field, value, tableIndex);
				this.props.changeStore2('recoverable',  (_.round(premiumFloat - parseFloat(value), 4)).toString(), tableIndex);
			}
		}
	};

	handlePercentagePremiumTableChange = (field, value, tableIndex, solicitorId) => {
		const { changeStore2, changeStore3 } = this.props;
	
		// Use a single condition to determine whether to set the field value to '' or a given value
		const newValue = value === '' ? '' : value;
	
		if (field === 'nonRecoverable' || field === 'underwriterRatePercentage') {
			changeStore2(field, newValue, tableIndex);
		} else if (field === 'commissionPercentage') {
			changeStore3(field, newValue, tableIndex, solicitorId);
		}
	};
	

	//function that returns the index of the item in the tableData array of the store
	//based on the case stage and damage index
	getTableIndex = (caseStageId, damageIndex) => {
		let tableData = this.props.premiumSettingsWizard.tableData;
		let selectedCaseStagesLength = this.props.premiumSettingsWizard.selectedCaseStages;
		let tempInd = 0;
		let returnIndex = null;
		_.forEach(tableData, (item, index) => {
			if (index % selectedCaseStagesLength === 0 && (index !== 0))
				tempInd = tempInd + 1;
			if (caseStageId === item.stageId) { //first find if case stage matches
				if (tempInd === damageIndex) { // then find out if the damage index matches
					returnIndex = index;
					return false;
				}
			}
		});
		return returnIndex;
	};

	//function that returns the index of the agent based on agent id
	getAgentIndex = (commisions, solicitorId) => {
		let agentIndex = _.findIndex(commisions, commission => {
			return commission.lawsysId === solicitorId
		});
		return agentIndex;
	};

	//function that find solicitor by id
	getSolicitor = (solicitorId) => {
		return _.find(this.props.lawsysFirms.selectedLawsysFirms, item => {
			return item.id === solicitorId ;
		})
	};

	//function that returns true if the table form is valid
	isTableFormValid = () => {
		let isValid = true;
		_.forEach(this.props.premiumSettingsWizard.tableData, item => {
			let acc = parseFloat(item.underwriterRatePercentage) + _.reduce(item.premiumSubSettingCommissions,  (accumulator, value) => {
					return accumulator + parseFloat(value.commissionPercentage)
				}, 0.00);
			if(acc > 100){
				isValid = false;
				return ;
			}
		});
		if(isValid)
			return true;
		else return false;
	};

	handleSubmitStep1 = (evt) => {
		evt.preventDefault();
		this.props.changeWizardStep('increase')
	};

	handleSubmitStep2 = (evt) => {
		evt.preventDefault();
		let damagesNotInDamageBands = this.getDamagesNotInDamageBands();
		let damageBands = [...this.props.premiumSettingsWizard.damageBands];
		let damages = [...this.props.damages];
		let finalDamageBands = [...damageBands];
		if (damagesNotInDamageBands.length > 0) {
			if (damageBands.length === 0) {
				this.props.changeStoreSettings('damageBands', [damages]);
			}
			else {
				if (damageBands.length === 1) {
					if (damageBands[0].length === damages.length) {
						this.props.changeStoreSettings('damageBands', [damages]);
						this.props.changeWizardStep('increase');
						return null;
					}
				}
				let tempDamageBand = [];
				_.forEach(damagesNotInDamageBands, (item, index) => {
					if (index === 0) {
						tempDamageBand.push(item);
						if (index + 1 === damagesNotInDamageBands.length) {
							finalDamageBands.push(tempDamageBand);
							tempDamageBand = [];
						}
					}
					else if (index + 1 === damagesNotInDamageBands.length) {
						if (this.areDamagesNeighbors(damagesNotInDamageBands[index - 1].sortOrder , item.sortOrder) ) {
							tempDamageBand.push(item);
							finalDamageBands.push(tempDamageBand);
						}
						else {
							if(tempDamageBand.length > 0){ finalDamageBands.push(tempDamageBand)}
							finalDamageBands.push([item]);
						}
						tempDamageBand = [];
					}
					else if (this.areDamagesNeighbors(damagesNotInDamageBands[index - 1].sortOrder , item.sortOrder)) {
						tempDamageBand.push(item)

					}
					else if (!this.areDamagesNeighbors(damagesNotInDamageBands[index - 1].sortOrder , item.sortOrder)) {
						finalDamageBands.push(tempDamageBand);
						tempDamageBand = [item];
					}
				});
				this.props.changeStoreSettings('damageBands', this.sortDamageBands(finalDamageBands));
			}
		}
		this.props.changeWizardStep('increase')
	};

	handleSubmitStep3 = (evt) => {
		evt.preventDefault();
		this.setStorePremiumSettingsObject();
		this.props.changeWizardStep('increase');
	};

	handleSubmitStep4 = (evt) => {
		evt.preventDefault();
		if(this.isTableFormValid()) {
			this.props.changeWizardStep('increase')
		}
		else {
			this.props.changeStoreSettings('validationMessage', 'Sum of underwriter rate and the solicitor\'s commission rate must not exceed the premium.');
		}
	};

	handleSubmitPercentageStep4 = (evt) => {
		evt.preventDefault();
		this.props.changeWizardStep('increase')
	};
	handleSubmitStep5 = (evt) => {
		evt.preventDefault();

        if(
        	!this.props.isApplicationPremium
        	&& moment(this.props.premiumSettingsWizard.validFrom, 'DD/MM/YYYY')
				.isBefore(moment().startOf('day'))
		) {
            this.props.changeStoreSettings('validationMessageStep5', 'Valid from date cannot be in the past.');
            return false;
        }
		if(
			!this.props.isApplicationPremium
			&& this.props.premiumSettingsWizard.validUntil
			&& moment(this.props.premiumSettingsWizard.validUntil, 'DD/MM/YYYY')
				.isBefore(moment(this.props.premiumSettingsWizard.validFrom, 'DD/MM/YYYY'))
		) {
			this.props.changeStoreSettings('validationMessageStep5', 'Valid until date cannot be before Valid from date.');
			return false;
		}
		this.props.changeWizardStep('increase')
	};

	handleSubmitStep6 = (evt) => {
		evt.preventDefault();
        if(this.props.isApplicationPremium && this.props.isChangingStatusOfApp){
            this.props.requestPatchApplicationPremiumSettings({
                sendBody: {
									id: this.props.premiumSettingsWizard.editId,
									notes: this.props.premiumSettingsWizard.notes,
									comments: this.props.premiumSettingsWizard.comments,
									endorsements: this.props.premiumSettingsWizard.endorsements,
									applicationPremiumSubSettingsDtos: this.getPremiumSubSettting(),
									limitOfIndemnity: parseFloat(this.props.premiumSettingsWizard.limitOfIndemnity),
									isPercentagePremium: this.props.premiumSettingsWizard.isPercentagePremium,
									recoverableRatePercentage: this.props.premiumSettingsWizard.recoverableRatePercentage,				
									DeductibleOptionId:this.props.premiumSettingsWizard.selectedDeductible,
									CoverageOptionId:this.props.premiumSettingsWizard.selectedCoverageType,
									EndorsementOptionId:this.props.premiumSettingsWizard.selectedEndorsement,
								},
                applicationId: this.props.applicationId,
                makeApplicationLive: true,
                sendEmail: this.props.sendEmail
            });
			return ;
        }

        if(this.props.isApplicationPremium && !this.props.isChangingStatusOfApp){
			this.props.requestPatchApplicationPremiumSettings({
				sendBody: {
					id: this.props.premiumSettingsWizard.editId,
					notes: this.props.premiumSettingsWizard.notes,
					comments: this.props.premiumSettingsWizard.comments,
					endorsements: this.props.premiumSettingsWizard.endorsements,
					applicationPremiumSubSettingsDtos: this.getPremiumSubSettting(),
					limitOfIndemnity: parseFloat(this.props.premiumSettingsWizard.limitOfIndemnity),
					isPercentagePremium: this.props.premiumSettingsWizard.isPercentagePremium,
					recoverableRatePercentage: this.props.premiumSettingsWizard.recoverableRatePercentage,
					DeductibleOptionId:this.props.premiumSettingsWizard.selectedDeductible,
					CoverageOptionId:this.props.premiumSettingsWizard.selectedCoverageType,
					EndorsementOptionId:this.props.premiumSettingsWizard.selectedEndorsement,
				},
				applicationId: this.props.applicationId
			});
			return ;
		}

		if(this.props.premiumSettingsWizard.isEditMode){
			this.props.requestPatchPremiumSetting({
				id: this.props.premiumSettingsWizard.editId,
				validFrom: this.props.premiumSettingsWizard.validFrom.toDateString(),
				validUntil: this.props.premiumSettingsWizard.validUntil ? this.props.premiumSettingsWizard.validUntil.toDateString() : null,
				notes: this.props.premiumSettingsWizard.notes,
				comments: this.props.premiumSettingsWizard.comments,
				endorsements: this.props.premiumSettingsWizard.endorsements,
				premiumSubSettings:this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE ? [] : this.getPremiumSubSettting(),
				percentagePremiumSubSettings: this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE ? this.getPremiumSubSettting() : [],
				limitOfIndemnity: parseFloat(this.props.premiumSettingsWizard.limitOfIndemnity),
				recoverableRatePercentage: this.props.premiumSettingsWizard.recoverableRatePercentage,
				caseTypeId: this.props.premiumSettingsWizard.caseTypeId,
				subCaseTypeId: this.props.premiumSettingsWizard.subCaseTypeId,
				solicitorGroupId: this.props.premiumSettingsWizard.solicitorGroupId ,
				workSourceId: this.props.premiumSettingsWizard.workSourceId,
				DeductibleOptionId:this.props.premiumSettingsWizard.selectedDeductible,
				CoverageOptionId:this.props.premiumSettingsWizard.selectedCoverageType,
				EndorsementOptionId:this.props.premiumSettingsWizard.selectedEndorsement,
				recoverableRatePercentage: this.props.premiumSettingsWizard.recoverableRatePercentage,
				premiumSettingTypePercentage : this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE,
			})
		}
		else{
			this.props.postNewPremiumSettingWizard({
				validFrom: this.props.premiumSettingsWizard.validFrom.toDateString(),
				validUntil: this.props.premiumSettingsWizard.validUntil ? this.props.premiumSettingsWizard.validUntil.toDateString() : null,
				notes: this.props.premiumSettingsWizard.notes,
				comments: this.props.premiumSettingsWizard.comments,
				endorsements: this.props.premiumSettingsWizard.endorsements,
				premiumSubSettings:this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE ? [] : this.getPremiumSubSettting(),
				percentagePremiumSubSettings: this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE ? this.getPremiumSubSettting() : [],
				limitOfIndemnity: parseFloat(this.props.premiumSettingsWizard.limitOfIndemnity),
				solicitorGroupId: this.props.selectedSolicitorGroup === '' ? null : parseInt(this.props.selectedSolicitorGroup),
				caseTypeId: parseInt(this.props.selectedCaseType),
				subCaseTypeId: this.props.selectedSubCaseType === ''|| this.props.selectedSubCaseType === '0' ? null : parseInt(this.props.selectedSubCaseType),
				workSourceId: this.props.selectedWorksource === '' ? null : parseInt(this.props.selectedWorksource),
				DeductibleOptionId:this.props.premiumSettingsWizard.selectedDeductible,
				CoverageOptionId:this.props.premiumSettingsWizard.selectedCoverageType,
				EndorsementOptionId:this.props.premiumSettingsWizard.selectedEndorsement,
				recoverableRatePercentage: this.props.premiumSettingsWizard.recoverableRatePercentage,
				premiumSettingTypePercentage: this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE,
			});
		}
	};

	//function that calculates the premiumSubSettings item to send it to the api
	getPremiumSubSettting = () => {
		let sendItem = [];
		_.forEach(this.props.premiumSettingsWizard.tableData, data => {
			let premiumSubSettings = [];
			_.forEach(data.premiumSubSettingCommissions, subSettings => {
				premiumSubSettings.push({
					commission: this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE ? 0 : parseFloat(subSettings.commission),
					commissionPercentage: parseFloat(subSettings.commissionPercentage),
					lawsysId: subSettings.lawsysId
				})
			});
			sendItem.push({
				stageId:data.stageId,
				damages:data.damages,
				premiumSubSettingCommissions: premiumSubSettings,
				premium:this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE ? 0 : parseFloat(data.premium),
				underwriterRate:this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE ? 0 : parseFloat(data.underwriterRate),
				underwriterRatePercentage: parseFloat(data.underwriterRatePercentage),
				recoverable: this.getSelectedCaseTypeName() === 'Clinical Negligence'?parseFloat(data.recoverable):null,
				nonRecoverable: this.getSelectedCaseTypeName() === 'Clinical Negligence'?parseFloat(data.nonRecoverable):null
			})
		});
		return sendItem
	};

	//function that returns the name of the selected case type
	getSelectedCaseTypeName = () => {
		if(
			this.props.premiumSettingsWizard.caseTypeName
			&& this.props.premiumSettingsWizard.isEditMode
		){
			return this.props.premiumSettingsWizard.caseTypeName;
		}

		let caseTypeId = null;
		if(this.props.selectedApplicationCaseTypeId){
			caseTypeId = this.props.selectedApplicationCaseTypeId;
		}

		if(this.props.selectedCaseType && !caseTypeId){
			caseTypeId = this.props.selectedCaseType;
		}

		if(!caseTypeId && !caseTypeId){
			return null;
		}

		let item = _.find(this.props.caseTypes, item => {
			return item.id.toString() === caseTypeId.toString()
		});
		if(item)
			return item.name;
		else return null
	};

	//function that returns the name of the sub case type of the selected case type
	getSelectedSubCaseTypeName = () => {
		if(
			this.props.premiumSettingsWizard.subCaseTypeName
			&& this.props.premiumSettingsWizard.isEditMode
		){
			return this.props.premiumSettingsWizard.subCaseTypeName;
		}

		let item = _.find(this.props.caseTypes, item => {
			return item.id.toString() === this.props.selectedCaseType
		});

		if (item) {
			let sendItem = _.find(item.subCaseTypes, item => {
				return item.id.toString() === this.props.selectedSubCaseType
			});
			if (sendItem)
				return sendItem.name;
			else return false
		} else return null
	};


	//function that return the step message
	getStepMessage = (stepNumber) => {
		if(this.props.premiumSettingsWizard.stepMessages.length === 0)
			return '';
		let stepMessage = '';
		_.forEach(this.props.premiumSettingsWizard.stepMessages, message => {
			if(message.position.includes(stepNumber.toString())){
				stepMessage = message.body;
				return false;
			}
		});
		return stepMessage;
	};

	getSolicitorGroupName = () => {
		if(
			this.props.premiumSettingsWizard.solicitorGroupName
			&& this.props.premiumSettingsWizard.isEditMode
		) {
			return this.props.premiumSettingsWizard.solicitorGroupName;
		}

		return this.props.selectedSolicitorGroupName;
	};

	getWorkSourceName = () => {
		if(
			this.props.premiumSettingsWizard.workSourceName
			&& this.props.premiumSettingsWizard.isEditMode
		){
			return this.props.premiumSettingsWizard.workSourceName;
		}

		return this.props.selectedWorksourceName;
	}

	onSuggestionChange = (value, action) => {
        if (action.action !== 'input-blur' && action.action !== 'menu-close')
        {
            if (value.length < 3)
            {
                this.props.changeLawsysFirmState('lawsysFirmsFiltered', []);
                this.props.changeLawsysFirmState('selectedLawsysFirmsDropdown', []);
				this.props.changeStoreSettings('selectedSolicitor', '');
            }
            this.props.changeLawsysFirmState('suggestionFieldValue', value);
        }
    };


    onSuggestionSelected = (value) => {
		let lawsysFirm  = this.props.lawsysFirms.lawsysFirmsFiltered.find(x => x.id === value.value);
        this.props.changeLawsysFirmState('lawsysFirmsFiltered', [lawsysFirm]);
        this.props.changeLawsysFirmState('selectedLawsysFirmsDropdown', [lawsysFirm]);
        this.props.changeLawsysFirmState('selectedLawsysFirms', [...this.props.lawsysFirms.selectedLawsysFirms, lawsysFirm]);
        this.props.changeStoreSettings('selectedSolicitor', value.value);
    };
	onCancelAppPremiumSettings = () => {
		this.props.requestDeleteApplicationPremiumSettings({
			applicationId:this.props.applicationId,
			appPremiumSettingId:this.props.premiumSettingsWizard.fetchedApplicationPremium?.id
		});
		this.props.changeApplicationPolicySettings('openPremiumSettingsModal', false) ;
		this.props.changeApplicationPolicySettings('premiumSettingsType', '') ;
		this.props.changeApplicationPolicySettings('multipleAppPremiumSettingsFound', false) ;
	}
	render() {
		let handleSubmit;
		switch (this.props.premiumSettingsWizard.currentStep) {
			case 1:
				handleSubmit = this.handleSubmitStep1;
				break;
			case 2:
				handleSubmit = this.handleSubmitStep2;
				break;
			case 3:
				handleSubmit = this.handleSubmitStep3;
				break;
			case 4:
				if(this.props.premiumSettingType === PS_TYPE_PERCENTAGE){
					handleSubmit = this.handleSubmitPercentageStep4;
				}
				else {
					handleSubmit = this.handleSubmitStep4;
				}
				break;
			case 5:
				handleSubmit = this.handleSubmitStep5;
				break;
			case 6:
				handleSubmit = this.handleSubmitStep6;
				break;
			default:
				handleSubmit = this.handleSubmitStep1;
		}
		//array with steps info
		let steps = [
			{name: 'Stages', stepNumber: 1},
			{name: 'Damage Bands', stepNumber: 2},
			{name: 'Commissions', stepNumber: 3},
			{name: 'Premiums', stepNumber: 4},
			{name: 'LOI & Notes', stepNumber: 5},
			{name: 'Overview', stepNumber: 6},
		];
		return (
			<PremiumSettingsWizard
				onCancelAppPremiumSettings={this.onCancelAppPremiumSettings}
				appPremiumSettingsIndicator={this.props.appPremiumSettingsIndicator}
				handleSubmitStep6={this.handleSubmitStep6}
                isChangingStatusOfApp={this.props.isChangingStatusOfApp}
				applicationPremiumCancelHandler={this.props.applicationPremiumCancelHandler}
				applicationPremiumSaveButtonLabel={this.props.applicationPremiumSaveButtonLabel}
				onApplicationPremiumEdit={this.props.onApplicationPremiumEdit}
                isApplicationPremium={this.props.isApplicationPremium}
				handleDateChange={this.handleDateChange} //date inputs handler
				goBack={this.props.goBack} //action that goes back in history routes
				premiumSettingTypeCustom={this.props.premiumSettingType === PS_TYPE_CUSTOM}
				premiumSettingTypePercentage={this.props.premiumSettingType === PS_TYPE_PERCENTAGE}
				getStepMessage={this.getStepMessage} //function that return the step message
				showTable={this.props.showTable} //flag that indicates that only the overview of the premium setting must be displayed
				handleRecoverableAndNonRecoverableChange={this.handleRecoverableAndNonRecoverableChange} //function that changes the store recoverable and non recoverable
				handlePercentagePremiumTableChange={this.handlePercentagePremiumTableChange} //function that changes the store for percentage premium table step 4
				fetchingCaseTypes={this.props.fetchingCaseTypes} //fetching case types indicator
				selectedSubCaseTypeName={this.getSelectedSubCaseTypeName()}  //function that returns the name of the sub case type of the selected case type
				selectedCaseType={this.getSelectedCaseTypeName()} // selected  case type name
				selectedSubCaseType={this.props.selectedSubCaseType} //selected sub case type
				selectedSolicitorGroupName={this.getSolicitorGroupName()} //selected Solicitor Group Name
				selectedWorksourceName={this.getWorkSourceName()} //selected Worksource Name
				getSolicitor={this.getSolicitor} //function that returns the solicitor by solicitor id
				getAgentIndex={this.getAgentIndex} //function that returns the index of the agent based on agent id
				getTableIndex={this.getTableIndex} //function that returns the index of the item in the tableData array of the store based on the case stage and damage index
				handleCommissionChange={this.handleCommissionChange}  //function that changes the store commissions
				handlePremiumAndUnderwriterChange={this.handlePremiumAndUnderwriterChange} //function that changes the store underwriter and premium
				getTableHeaderData={this.getTableHeaderData}  //function that calculated the table header data
				removeSolicitor={this.removeSolicitor}  //function that removes a solicitor from the list
				addSolicitor={this.addSolicitor} //function that add a solicitor to the solicitor list
				getEndDamageBands={this.getEndDamageBands} //function that gets the damage objects available for the first select list of the damage modal
				getStartDamageBands={this.getStartDamageBands} //function that gets the damage objects available for the first select list of the damage modal
				setDamageBand={this.setDamageBand} //function that calculates the damage band according to the given design
				removeDamageBand={this.removeDamageBand}   //function that removes a damage band
				getDamageBandName={this.getDamageBandName}  //function that calculates the damage band label
				changeStepThroughProgressBar={this.changeStepThroughProgressBar} // function that changes step through progress bar
				steps={steps} //array with steps info
				handleSubmit={handleSubmit}
				changeStoreSettings={this.props.changeStoreSettings} //action that changes the store settings
				handleCaseStagesSelectMultipleChange={this.handleCaseStagesSelectMultipleChange} //handler for selecting multiple case stages
				handleCaseStagesCheckedState={this.handleCaseStagesCheckedState} //handler for storing the selected case stages ids
				premiumSettingsWizard={this.props.premiumSettingsWizard} //store
				changeWizardStep={this.props.changeWizardStep} //wizard step handler
				lawsysFirms={this.props.lawsysFirms} //solicitor firms
				damages={this.props.damages} //premium settings damages
				fetchingDamages={this.props.fetchingDamages} //fetch damages state
				addNewDamageBand={this.addNewDamageBand} //function that adds new damage band
				getDamagesNotInDamageBands={this.getDamagesNotInDamageBands} //function that computed the damages that are not a member of any damage band
				caseStages={this.props.caseStages} //case stages
				fetchingStages={this.props.fetchingStages} // fetch case stages state
				selectedCoverageType={this.props.premiumSettingsWizard.selectedCoverageType}
				selectedDeductible={this.props.premiumSettingsWizard.selectedDeductible}
				selectedEndorsement={this.props.premiumSettingsWizard.selectedEndorsement}
				displayedCoverageType={this.props.premiumSettingsWizard.displayedCoverageType}
				displayedDeductible={this.props.premiumSettingsWizard.displayedDeductible}
				displayedEndorsement={this.props.premiumSettingsWizard.displayedEndorsement}
				coveragesOptions={this.props.premiumSettingsWizard.coveragesOptions}
				deductiblesOptions={this.props.premiumSettingsWizard.deductiblesOptions}
				endorsementsOptions={this.props.premiumSettingsWizard.endorsementsOptions}
				onSuggestionSelected={this.onSuggestionSelected}
                onSuggestionChange={this.onSuggestionChange}
				changeLawsysFirmState={this.props.changeLawsysFirmState}
			/>
		)
	}

}

const mapStateToProps = (state) => {
	return {
		router: state.router,
		premiumSettingsWizard: state.premiumSettingsWizard,
		premiumSettings: state.premiumSettings,
		lawsysFirms: state.lawsysFirms,
		damages: state.damages.damages,
		damagesSortOrders: state.damages.damagesSortOrders,
		fetchingDamages: state.damages.fetchingDamages,
		caseStages: state.premiumSettings.stages,
		fetchingStages: state.premiumSettings.fetchingStages,
		selectedSolicitorGroup: state.premiumSettings.selectedSolicitorGroup,
		selectedCaseType: state.premiumSettings.selectedCaseType,
		selectedSubCaseType: state.premiumSettings.selectedSubCaseType,
		caseTypes: state.caseTypes.cases,
		fetchingCaseTypes: state.caseTypes.fetching,
		selectedWorksource: state.premiumSettings.selectedWorksource,
		selectedSolicitorGroupName: state.premiumSettings.selectedSolicitorGroupName,
		selectedWorksourceName: state.premiumSettings.selectedWorksourceName,
		premiumSettingType: state.premiumSettings.psType,
		applicationId: state.applicationsAndPolicies.selectedApplication.id,
        sendEmail:state.applicationPolicy.sendEmailNotification,
		patchingApplication: state.applicationPolicy.patching,
		appPremiumSettingsIndicator: state.applicationPolicy.premiumSettingsIndicator
    }
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeWizardStep: (type) => {
			dispatch(changeWizardStep(type))
		},
		requestLawsysFirmsFiltered: (payload) => {
            dispatch(requestLawsysFirmsFiltered(payload))
        },
		changeLawsysFirmState: (key, value) => {
            dispatch(changeLawsysFirmState(key, value))
        },
		requestPremiumSettingsDamages: () => {
			dispatch(requestPremiumSettingsDamages())
		},
		requestPremiumSettingsStages: () => {
			dispatch(requestPremiumSettingsStages())
		},
		changeStoreSettings: (key, value) => {
			dispatch(changePremiumSettingsWizardStore(key, value))
		},
		changeStore2: (field, value, tableIndex) => { //change store settings related with damage range and case stage
			dispatch(changePremiumSettingsWizardStoreByDamageAndCaseStage(field, value, tableIndex))
		},
		changeStore3: (field, value, tableIndex, solicitorId) => { //change store settings related with damage range case stage and solicitor
			dispatch(changePremiumSettingsWizardStoreByDamageCaseStageAndSolicitor(field, value, tableIndex, solicitorId))
		},
		postNewPremiumSettingWizard: (sendBody) => {
			dispatch(postNewPremiumSettingWizard(sendBody))
		},
		getCaseTypes: () => {
			dispatch(getCaseTypes())
		},
		getPremiumSettingsWizardStepMessages: () => {
			dispatch(getPremiumSettingsWizardStepMessages())
		},
		requestGetSpecificPremiumSetting: (payload) => {
			dispatch(requestGetSpecificPremiumSetting(payload))
		},
		requestPatchPremiumSetting: (sendBody) => {
			dispatch(requestPatchPremiumSetting(sendBody))
		},
		requestDeleteApplicationPremiumSettings: (payload) => {
			dispatch(requestDeleteApplicationPremiumSettings(payload))
		},
		goBack: () => {
			dispatch(goBack())
		},
		requestPatchApplicationPremiumSettings: (sendBody) => {
			dispatch(requestPatchApplicationPremiumSettings(sendBody))
		},
		getCoverageTypes: (payload) => {
			dispatch(getCoverageTypes(payload))
		},
		changeApplicationPolicySettings: (setting, value) => {
			dispatch(changeApplicationPolicySettings(setting, value));
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumSettingsWizardHOC);
